import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex white align-center justify-space-between pa-2" }
const _hoisted_2 = { class: "d-flex white align-center justify-space-between pa-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "filter-card benchmark" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          "model-value": _ctx.currentFilters.tax_year,
                          items: _ctx.filters.tax_year,
                          "hide-details": true,
                          variant: "underlined",
                          chips: "",
                          clearable: true,
                          "allow-overflow": false,
                          color: "primary",
                          label: "Tax Year",
                          "item-title": "name",
                          "item-value": "id",
                          multiple: "",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                  (e) => {
                    _ctx.updateTaxYear(e);
                  }
                )
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              close: "",
                              class: "filter-chips mx-1 my-1",
                              size: "default"
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(item.raw), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              title: item.raw
                            }), null, 16, ["title"])
                          ]),
                          _: 1
                        }, 8, ["model-value", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          "model-value": _ctx.currentFilters.scheme,
                          items: _ctx.filters.scheme,
                          "hide-details": true,
                          variant: "underlined",
                          chips: "",
                          clearable: true,
                          "allow-overflow": false,
                          color: "primary",
                          label: "Type of Scheme",
                          "item-title": "name",
                          "item-value": "id",
                          multiple: "",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                  (e) => {
                    _ctx.updateScheme(e);
                  }
                )
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              close: "",
                              class: "filter-chips mx-1 my-1",
                              size: "default"
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(item.raw), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              title: item.raw
                            }), null, 16, ["title"])
                          ]),
                          _: 1
                        }, 8, ["model-value", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          "model-value": _ctx.currentFilters.pathway,
                          items: _ctx.filters.pathway,
                          "hide-details": true,
                          variant: "underlined",
                          chips: "",
                          clearable: true,
                          "allow-overflow": false,
                          color: "primary",
                          label: "Pathway",
                          "item-title": "name",
                          "item-value": "id",
                          multiple: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = 
                  (e) => {
                    _ctx.updatePathWay(e);
                  }
                )
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              close: "",
                              class: "filter-chips mx-1 my-1",
                              size: "default"
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(item.raw), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              title: item.raw
                            }), null, 16, ["title"])
                          ]),
                          _: 1
                        }, 8, ["model-value", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          "model-value": _ctx.currentFilters.data_type,
                          items: _ctx.filters.data_type,
                          "hide-details": true,
                          variant: "underlined",
                          chips: "",
                          clearable: true,
                          "allow-overflow": false,
                          color: "primary",
                          label: "Data Type",
                          "item-title": "name",
                          "item-value": "id",
                          multiple: "",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = 
                  (e) => {
                    _ctx.updateDataType(e);
                  }
                )
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              close: "",
                              class: "filter-chips mx-1 my-1",
                              size: "default"
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(item.raw), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              title: item.raw
                            }), null, 16, ["title"])
                          ]),
                          _: 1
                        }, 8, ["model-value", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          "model-value": _ctx.currentFilters.consolidator,
                          items: _ctx.filters.consolidator,
                          "hide-details": true,
                          variant: "underlined",
                          chips: "",
                          clearable: true,
                          "allow-overflow": false,
                          color: "primary",
                          label: "Consolidator",
                          "item-title": "name",
                          "item-value": "id",
                          multiple: "",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = 
                  (e) => {
                    _ctx.updateConsolidator(e);
                  }
                )
                        }, {
                          chip: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_chip, _mergeProps(props, {
                              close: "",
                              class: "filter-chips mx-1 my-1",
                              size: "default"
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(item.raw), 1)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              title: item.raw
                            }), null, 16, ["title"])
                          ]),
                          _: 1
                        }, 8, ["model-value", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  xs: 6,
                  md: 4,
                  class: "pb-0 px-7 providerFilter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-center": "",
                      "justify-space-between": "",
                      class: "filter-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-3"
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("fas fa-coins", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Pot Size", -1))
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_btn, {
                          flat: "",
                          size: "small",
                          icon: "",
                          class: "reset-filter-btn",
                          onClick: _cache[5] || (_cache[5] = _withModifiers((e) => _ctx.resetFilter('asset_size'), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("fas fa-times", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.potRangeIsDirty]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_range_slider, {
                      "model-value": _ctx.currentFilters.asset_size || [],
                      max: _ctx.filters.asset_size.max,
                      min: _ctx.filters.asset_size.min,
                      "hide-details": "",
                      "track-size": 1,
                      "thumb-size": 12,
                      "track-color": "#e4dbf1",
                      color: "primary",
                      class: "align-center mt-2 px-3",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = (e) => _ctx.updateAssetSize(e))
                    }, null, 8, ["model-value", "max", "min"]),
                    (_ctx.currentFilters.asset_size)
                      ? (_openBlock(), _createBlock(_component_v_layout, {
                          key: 0,
                          class: "filter-value mx-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.minmenu,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.minmenu) = $event)),
                              "close-on-content-click": false,
                              "close-on-click": false,
                              "content-class": "filter-edit-menus",
                              offset: "10",
                              location: "right"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.asset_size[0], '$0.0a')), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.asset_size[0],
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentFilters.asset_size[0]) = $event)),
                                    height: 14,
                                    variant: "outlined",
                                    density: "compact",
                                    dense: "",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.minmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.maxmenu,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.maxmenu) = $event)),
                              "close-on-content-click": false,
                              "close-on-click": false,
                              "content-class": "filter-edit-menus",
                              offset: "10",
                              location: "right"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.asset_size[1], '$0.0a')), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.asset_size[1],
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentFilters.asset_size[1]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.maxmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  xs: 12,
                  class: "filter-col mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-end": "",
                      class: "d-flex justify-end mr-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          depressed: "",
                          light: "",
                          onClick: _ctx.resetFilters
                        }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("Reset", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          onClick: _withModifiers(_ctx.applyFilter, ["stop"]),
                          color: !_ctx.filtersAreDirty || !(_ctx.isVFMUser || _ctx.isSuperUser) ? 'disbaled' : 'success',
                          class: "ml-3",
                          disabled: !_ctx.filtersAreDirty || !(_ctx.isVFMUser || _ctx.isSuperUser)
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("Apply", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "color", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}